"use client";

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/shared/lib/utils";
interface ReadMoreTextProps {
  text: string;
  locale: "en" | "hi";
}
export function ReadMoreText(t0) {
  const $ = _c(16);
  const {
    text,
    locale
  } = t0;
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const paragraphRef = useRef(null);
  const isHindi = locale === "hi";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = paragraphRef.current;
      if (!el) {
        return;
      }
      const measure = () => setIsClamped(el.scrollHeight > el.clientHeight + 1);
      measure();
      const observer = new ResizeObserver(measure);
      observer.observe(el);
      return () => observer.disconnect();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== expanded || $[2] !== text) {
    t2 = [text, expanded];
    $[1] = expanded;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  const t3 = !expanded && "line-clamp-4";
  let t4;
  if ($[4] !== t3) {
    t4 = cn("text-[15px] leading-7 font-light whitespace-pre-line text-muted-foreground", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4 || $[7] !== text) {
    t5 = <p ref={paragraphRef} className={t4}>{text}</p>;
    $[6] = t4;
    $[7] = text;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== expanded || $[10] !== isClamped || $[11] !== isHindi) {
    t6 = (isClamped || expanded) && <button type="button" onClick={() => setExpanded(_temp)} className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline">{expanded ? isHindi ? "\u0915\u092E \u0926\u093F\u0916\u093E\u090F\u0902" : "Show less" : isHindi ? "\u0914\u0930 \u092A\u0922\u093C\u0947\u0902" : "Read more"}{expanded ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}</button>;
    $[9] = expanded;
    $[10] = isClamped;
    $[11] = isHindi;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(prev) {
  return !prev;
}